import script from "./FaqVue.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqVue.vue?vue&type=script&setup=true&lang=js"

import "./FaqVue.vue?vue&type=style&index=0&id=f31069fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f31069fc"]])

export default __exports__